export const RADAR_PATH = '/radar_3857/';
export const API_URL = '14.39.185.139:30117';
